import React from "react";
import { useLang } from "../context/lang";
import Dropdown from "react-bootstrap/Dropdown";
import { TriangleDownIcon } from "@primer/octicons-react";
import { ReactComponent as Globe } from "../assets/globe.svg";

const ChangeLanguageComponent = ({
  hideIcon = false,
  light = false,
  compact = false,
  showLangNames = false,
  onChange,
}: any) => {
  const { lang, setLang, getAvailableLangs, t } = useLang();

  const getLangLabel = (code: string) =>
    showLangNames ? t(`langOption_${code}`) || code.toUpperCase() : code.toUpperCase();

  return (
    <div
      className={`change-language-wrap d-flex align-items-center ${
        compact ? "change-language-wrap--compact" : "w-100"
      }`}
    >
      {!hideIcon && (
        <Globe
          className={`globe-icon ${compact ? "login-globe-icon" : "ml-32 my-xl-16 my-8 mr-16"}`}
          aria-hidden="true"
        />
      )}
      <Dropdown className={`${light ? "m-0" : "mx-4"}`}>
        <Dropdown.Toggle
          variant="outline-light"
          aria-label={t("changeLanguage")}
          className={`${
            light
              ? "bg-white hover-blue"
              : "bg-gray-800 hover-bg-gray-700 border-0"
          }   no-after flex-center-between`}
        >
          <span>
            <span className={`lang-label ${light ? "text-dark" : "text-white-50"} mr-16`}>
              {getLangLabel(lang)}
            </span>
          </span>
          <span
            className={`lang-chevron ${light ? "text-dark" : "text-white-50"} d-flex`}
          >
            <TriangleDownIcon />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu align="right">
          {getAvailableLangs().map((option: any, key: any) => (
            <Dropdown.Item
              key={key}
              onClick={() => {
                setLang(option.code);
                if (onChange) onChange(option.code);
              }}
            >
              {getLangLabel(option.code)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ChangeLanguageComponent;
